import { ComponentStyleConfig, theme as baseTheme } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

const { radio: { bgBorderColor, bgColor } } = primaryColor

export const Radio: ComponentStyleConfig = {
  parts: ['control'],
  baseStyle: {
    ...baseTheme.components.Radio.baseStyle,
    control: {
      _checked: {
        bg:bgColor,
        borderColor:bgBorderColor,
        color:bgBorderColor,
        _hover: {
          borderColor:bgBorderColor,
          bg:bgColor,
        },
      },
      _hover: {
        borderColor:bgBorderColor,
      },
    }
  },
}
